export default {
  getUrlKey:function(name){
    //return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href)||[ ,""])[1].replace(/\+/g,'%20'))||null;
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href)||[""])[1].replace(/\+/g,'%20'))||null;
  },
  /*西元(UTC)年轉民國年YYYMMDD
    in : adDate 西元年(UTC Dates (Date-Time)格式) 2018-07-12T16:00:00Z[UTC]
    return : YYY/MM/DD
    sample : $UtilityJs.AD2ROC_Date(item.createDate)
   */
  AD2ROC_Date:function (adDate) {
    let date = new Date(adDate.replace('[UTC]', '')); //去掉[UTC]
    let YYY = date.getFullYear() - 1911;
    let MM = ("0" + (date.getMonth() + 1)).slice(-2);   //0-11
    let DD = ("0" + date.getDate()).slice(-2);  //1-31
    //console.log("date : " + date);
    return YYY + "/" + MM + "/" + DD;
  },
  AD2ROC_DateTime:function (adDate,dateOrTime) {  //轉換Date格式 1071125 add by IvyLin
    if(adDate==''||adDate==undefined||adDate==null){
      return '';
    }else{
      let date = new Date(adDate.replace('[UTC]', '')); //去掉[UTC]
      let YYYY = date.getFullYear();
      let MM = ("0" + (date.getMonth() + 1)).slice(-2);   //0-11
      let DD = ("0" + date.getDate()).slice(-2);  //1-31
      let hh = ("0" + date.getHours()).slice(-2);  //0-24
      let mm = ("0" + date.getMinutes()).slice(-2);  //00-59
      let ss = ("0" + date.getSeconds()).slice(-2);  //00-59

      if(dateOrTime =='date'){
        return YYYY + "-" + MM + "-" + DD;
      }else if(dateOrTime =='time'){
        return hh + ":" + mm;
      }else if(dateOrTime=='all'){
        return YYYY + "-" + MM + "-" + DD + " "+ hh + ":"+ mm + ":" + ss;
      }else if(dateOrTime=='showDT'){
        return YYYY + "-" + MM + "-" + DD + " "+ hh + ":"+ mm;
      }else if(dateOrTime=='year'){
        return YYYY;
      }else if(dateOrTime=='month'){
        return MM;
      }
    }

  },
  DateAdd:function (interval, number, date) {
    switch (interval) {
      case "y": {
        date.setFullYear(date.getFullYear() + number);
        return date;

      }
      case "q": {
        date.setMonth(date.getMonth() + number * 3);
        return date;

      }
      case "m": {
        date.setMonth(date.getMonth() + number);
        return date;

      }
      case "w": {
        date.setDate(date.getDate() + number * 7);
        return date;

      }
      case "d": {
        date.setDate(date.getDate() + number);
        return date;

      }
      case "h": {
        date.setHours(date.getHours() + number);
        return date;

      }
      case "M": {
        date.setMinutes(date.getMinutes() + number);
        return date;

      }
      case "s": {
        date.setSeconds(date.getSeconds() + number);
        return date;

      }
      default: {
        date.setDate(date.getDate() + number);
        return date;

      }
    }
  },

  //民國轉西元年
  transROC2YMD:function(date){
    if(date==''||date==undefined||date==null){
      return '';
    }else{
      let y = date.substring(0,3);
      y = parseInt(y)+1911;
      let m = date.substring(3,5);
      let d = date.substring(5,7);
      return y+""+m+""+d;
    }

  },

  //民國轉西元年 格式化
  transROC2YMDFormat:function(date){
    if(date==''||date==undefined||date==null){
      return '';
    }else{
      let y = date.substring(0,3);
      y = parseInt(y)+1911;
      let m = date.substring(3,5);
      let d = date.substring(5,7);
      return y+"-"+m+"-"+d;
    }

  },


  /* not test */
  Process_Duplicate:function (val, myArr) {
    return myArr.filter((obj, pos, arr) => {
      return arr.map(mapObj => mapObj[val]).indexOf(obj[val]) === pos;
    });
  },
  /** 格式化 從Api取得的民國年日期時間
   * @cellValue  日期 / 時間  String
   * */
  formatDateTime:function(cellValue) {
    let y, m, d;
    let hh, mm, ss;
    if(cellValue === undefined || cellValue === null||cellValue=="[object Window]"||cellValue==""||cellValue=="null"){
      return "";

    }else{
      if(cellValue.length==7){
        y = cellValue.substring(0,3);
        m = cellValue.substring(3,5);
        d = cellValue.substring(5,7);
//	   			 console.log(y+"/"+m+"/"+d);
        if(cellValue.startsWith("0")){
          y = cellValue.substring(1,3); //如果民國年小於 100年 ，去除前面的0
        }
        return y+"/"+m+"/"+d;

      }else if(cellValue.length==6){
        hh = cellValue.substring(0,2);
        mm = cellValue.substring(2,4);
        ss = cellValue.substring(4,6);
//	   			 console.log(hh+":"+mm+":"+ss);
        return hh+":"+mm+":"+ss;

      }else if(cellValue.length==11){ //例:手術輸入日期 10702261546

        y = cellValue.substring(0,3);
        m = cellValue.substring(3,5);
        d = cellValue.substring(5,7);
        if(cellValue.startsWith("0")){
          y = cellValue.substring(1,3); //如果民國年小於 100年 ，去除前面的0
        }
        hh = cellValue.substring(7,9);
        mm = cellValue.substring(9,11);

        return y+"/"+m+"/"+d+"  "+hh+":"+mm;


      }else{
        hh = cellValue.substring(0,2);
        mm = cellValue.substring(2,4);
//	   			 console.log(hh+":"+mm);
        return hh+":"+mm;

      }
    }

  },
  /*
       功能 : 轉換 Json DateTime to Date
       範例 : this.$UtilityJs.convertJsonDate
       範例 : {{$UtilityJs.convertJsonDate(props.item.displayData._FormSearch.DATE)}}
   */
  convertJsonDate: function (value) {
    let tDate = new Date(value);
    let month =  ("0" + (tDate.getMonth() + 1)).slice(-2);
    let day = ("0" + (tDate.getDate())).slice(-2);
    let year = tDate.getFullYear();

    let hour = ("0" + (tDate.getHours())).slice(-2);
    let min = ("0" + (tDate.getMinutes())).slice(-2);
    return year + "/" + month + "/" + day + " " + hour + ":" + min;
  }



}
